import { MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { MatDialogModule, MatButtonModule, MatProgressBarModule,MatDialog } from '@angular/material';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
// import { SignupComponent } from './signup/signup.component';
// import { TabsComponent,BottomSheetOverviewExampleSheet,DialogOverviewExampleDialog,ExperiencePopup } from './tabs/tabs.component';

// import { WelcomeComponent } from './welcome/welcome.component';
// import { PersonalInformationComponent } from './personal-information/personal-information.component';
// import { ContactInformationComponent } from './contact-information/contact-information.component';
// import { EducationComponent } from './education/education.component';
// import { ExperienceComponent } from './experience/experience.component';

// import { ConfirmationComponent } from './confirmation/confirmation.component';
// import { FilterPipe, TruncatePipe, DonwloadPipe } from './Helper';
// import { KnqfComponent } from './knqf/knqf.component';
// import { ContentLoaderModule } from '@netbasal/ngx-content-loader';
import { AlertComponent } from './alert/alert.component';

import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { SuccessBoxComponent } from './components/success-box/success-box.component';

import { AngularEditorModule } from '@kolkov/angular-editor';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { MaterialSharedModule } from './material-shared/material-shared.module';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFileUploadComponent } from './angular-file-upload/angular-file-upload.component';
import { PaymentPopupComponent } from './payment-popup/payment-popup.component';
// import { DialogOverviewExampleDialog } from './curriculum-developer/application/dialog-overview-example-dialog';


// import { PaymentComponent } from './payment/payment.component';
// import { DashboardComponent } from './dashboard/dashboard.component';
// import { ChangePasswordComponent } from './change-password/change-password.component';
// import { HeaderComponent } from './layout/header/header.component';
// import { FooterComponent } from './layout/footer/footer.component';

// import { ReadMoreComponent } from './read-more/read-more.component';
// import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
// import { TrainerLeftSidebarComponent } from './trainer-left-sidebar/trainer-left-sidebar.component';
// import { CustomerListComponent } from './customers/customer-list/customer-list.component';
// import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
@NgModule({
  declarations: [
    AppComponent,
    TermsConditionComponent,

    // SignupComponent,
    // TabsComponent,
    // BottomSheetOverviewExampleSheet,
    // DialogOverviewExampleDialog,
    // ExperiencePopup,
    // WelcomeComponent,
    // PersonalInformationComponent,
    // ContactInformationComponent,
    // EducationComponent,
    // ExperienceComponent,
    // ConfirmationComponent,
    // FilterPipe,
    // DonwloadPipe,
    // KnqfComponent,
    AlertComponent,


    SuccessBoxComponent,
    DocumentViewerComponent,
    AngularFileUploadComponent,
    PaymentPopupComponent,
    // DialogOverviewExampleDialog








    // PaymentComponent,
    // TruncatePipe,
    // DashboardComponent,
    // ChangePasswordComponent,
    // HeaderComponent,
    // FooterComponent,

    // ReadMoreComponent,
    // SearchableSelectComponent,
    // TrainerLeftSidebarComponent,
    // CustomerListComponent

  ],
  entryComponents:[
    AlertComponent,
    TermsConditionComponent,
    SuccessBoxComponent,
    DocumentViewerComponent,
    PaymentPopupComponent,
    // DialogOverviewExampleDialog

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule,
    AngularEditorModule,
    MaterialSharedModule,
//     ServiceWorkerModule.register('ngsw-worker.js', { enabled: true, registrationStrategy: 'registerImmediately', })
     // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    // ContentLoaderModule,

  ],
  // providers:[MatDialog],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
